/// <amd-module name="VSS/Features/PlatformUI/Constants" />
export namespace Constants {
    export const DisableDynamicTabsProcessing = "WebAccess.Agile.DisableDynamicTabsProcessing";
}
